import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface IContext {
  isOpenUserModal: boolean
  toggleUserModal: (isOpen: boolean) => void
}

export const UserListViewContext = createContext<IContext>({
  isOpenUserModal: false,
  toggleUserModal: () => {},
})

export const UserListViewContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [isOpenUserModal, setIsOpenUserModal] = useState(false)

  const toggleUserModal = (isOpen: boolean) => {
    setIsOpenUserModal(isOpen)
  }

  return (
    <UserListViewContext.Provider
      value={{
        isOpenUserModal,
        toggleUserModal,
      }}>
      {children}
    </UserListViewContext.Provider>
  )
}
